import { render, staticRenderFns } from "./DRSelect.vue?vue&type=template&id=c85861aa&scoped=true&"
import script from "./DRSelect.vue?vue&type=script&lang=js&"
export * from "./DRSelect.vue?vue&type=script&lang=js&"
import style0 from "./DRSelect.vue?vue&type=style&index=0&id=c85861aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85861aa",
  null
  
)

/* custom blocks */
import block0 from "./DRSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports